var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-aside',{attrs:{"width":"auto"}},[_c('left-menu',{attrs:{"user":_vm.user,"items":_vm.menuItems,"collapse":_vm.isCollapsed}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }